module.exports = __webpack_public_path__ + "media/images/emblems/Frutigen-coat_of_arms-a46a6697d9bbef1fe381484d9aa7ed0b.svg";